(function($) {
    var videos = {};
    var $buttons = $('.video-button, .button__video');

    if (!$buttons.length) {
        return;
    }

    function getVideo(path) {
        if (!videos.hasOwnProperty(path)) {
            var $video = $('<div class="video-overlay">' +
            '<button class="video-overlay__close"><div class="fa fa-times"></div><span class="visuallyhidden">Close<span></button>' +
            //'<div class="video-container">' +
                '<iframe src="https://player.vimeo.com/video/'+path+'?autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
            //'</div>' +
            '</div>');

            $video.find('.video-overlay__close').on('click', function() {
                closeVideo($video);
            });

            videos[path] = $video;
        }
        return videos[path];
    }

    function closeVideo($video) {
        $video
            .removeClass('is-active');
        setTimeout(function() {
            $video.detach();
        }, 1000);
    }

    function openVideo($video) {
        $video
            .appendTo('body');
        setTimeout(function() {
            $video.addClass('is-active');
        }, 200);
    }

    $buttons.click(function(e) {

        e.preventDefault();

        var video = $(this).data('video');

        if (!video) {
            return;
        }

        var $video = getVideo(video);

        if (!$video.hasClass('is-active')) {
            openVideo($video);
        } else {
            closeVideo($video);
        }
    });

}(jQuery));
